"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
exports.__esModule = true;
exports.VendorFacet = void 0;
var __1 = require("./../");
var VendorFacet = /** @class */ (function (_super) {
    __extends(VendorFacet, _super);
    function VendorFacet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VendorFacet.prototype.getOptions = function () {
        return __spreadArray([], this.template.data.allVendors);
    };
    return VendorFacet;
}(__1.Facet));
exports.VendorFacet = VendorFacet;
//# sourceMappingURL=VendorFacet.js.map